/*
 * @Author: liyxt
 * @Date: 2019-10-14 11:19:57
 * @LastEditors: liyxt
 * @LastEditTime: 2019-10-14 14:19:02
 * @Description: file content
 */
/*
*   between 类型的number组件
* */
import React, { Component } from 'react';
import { isFunction, isArray } from '@platform/api';
import FormControl from '../-FormControl';
import { getSysFieldid } from '@platform/api';

require('./index.less');

class BetweenInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            start: { placeholder: props.placeholder },
            end: { placeholder: props.placeholder },
            disabled: props.disabled,
        };
        this.mergeData(props);
    }

    /* props 更新 */
    componentWillReceiveProps(props) {
        this.mergeData(props);
        this.setState(this.state);
    }

    /* 合并数据 */
    mergeData(props) {
        this.state.start.placeholder = props.defaultPlaceholder.start;
        this.state.end.placeholder = props.defaultPlaceholder.end;
        this.state.disabled = props.disabled;
        if (props.value && isArray(props.value)) {
            // if( props.value[0] > props.value[1] ){
            //     console.error('BetweenNum控件的起始值不能大于结束值');
            //     return false
            // }
            this.state.start.value = props.value[0];
            this.state.end.value = props.value[1];
        } else if (props.value && !isArray(props.value)) {
            console.error('BetweenNum控件的value值为数组类型');
            return false;
        }
    }

    /* 失去焦点事件 */
    inputBlur(pos, val) {
        // if( pos === 'end' && val < this.state.start.value ){
        //     Message.create({ content: 'between类型的控件，结束值不能小于起始值', color: 'danger' });
        //     val = this.state.start.value;
        // }
        // if( pos === 'start' && val > this.state.end.value ){
        //     Message.create({ content: 'between类型的控件，起始值不能大于结束值', color: 'danger' });
        //     val = this.state.end.value;
        // }
        this.state[pos].value = val;
        this.setState(this.state);
        if (isFunction(this.props.onBlur)) {
            let res = [this.state.start.value, this.state.end.value];
            this.props.onBlur(res);
        }
    }

    /* change事件 */
    changeNumber(pos, val) {
        this.state[pos].value = val;
        this.setState(this.state);
        if (isFunction(this.props.onChange)) {
            let res = [this.state.start.value, this.state.end.value];
            this.props.onChange(res);
        }
    }

    render() {
        let { fieldid, mustFill, ...others } = this.props;
        fieldid = getSysFieldid(fieldid);
        return (
            <div className="BetweenInput" fieldid={fieldid || null}>
                <div className="startInput">
                    <FormControl
                        {...others}
                        onBlur={this.inputBlur.bind(this, 'start')}
                        // scale={ this.state.scale }
                        value={this.state.start.value ? this.state.start.value : ''}
                        placeholder={this.state.start.placeholder}
                        disabled={this.state.disabled}
                        onChange={this.changeNumber.bind(this, 'start')}
                    />
                </div>
                <span className="betweenLine">-</span>
                {mustFill}
                <div className="endInput">
                    <FormControl
                        {...others}
                        onBlur={this.inputBlur.bind(this, 'end')}
                        // scale={ this.state.scale }
                        value={this.state.end.value ? this.state.end.value : ''}
                        placeholder={this.state.end.placeholder}
                        disabled={this.state.disabled}
                        onChange={this.changeNumber.bind(this, 'end')}
                    />
                </div>
            </div>
        );
    }
}

export default BetweenInput;
